import {
    GET_VOLUNTEER
} from '../constants/volunteer.js';

export const initialState = {
    volunteer: {}
};

export function volunteerReducer( state = initialState, action ) {

    switch ( action.type ) {

        case GET_VOLUNTEER:
            return Object.assign( {}, state, {
                volunteer: action.volunteer
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/volunteer.js